"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var R = _interopRequireWildcard(require("ramda"));
var _chooseFootnotes = _interopRequireDefault(require("../footnotes/chooseFootnotes"));
var _getFootnotePlaceholder = _interopRequireDefault(require("../footnotes/getFootnotePlaceholder"));
var _getFootnotes = _interopRequireDefault(require("../footnotes/getFootnotes"));
var _mapFootnotesToView = _interopRequireDefault(require("../footnotes/mapFootnotesToView"));
var _createInstance = _interopRequireDefault(require("../node/createInstance"));
var _isFixed = _interopRequireDefault(require("../node/isFixed"));
var _splitNodes4 = _interopRequireDefault(require("../node/splitNodes"));
var _getContentArea = _interopRequireDefault(require("../page/getContentArea"));
var _getWrapArea = _interopRequireDefault(require("../page/getWrapArea"));
var _resolveDimensions = require("./resolveDimensions");
var _resolveInheritance = _interopRequireDefault(require("./resolveInheritance"));
var _resolveTextLayout = _interopRequireDefault(require("./resolveTextLayout"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable prefer-destructuring */

var assingChildren = R.assoc('children');
var getHeight = R.path(['box', 'height']);

/* All the children are fixed */
var isAllChildrenFixed = function isAllChildrenFixed(n) {
  return R.all(_isFixed.default)(n.children);
};

/* Node itself is fixed OR has only fixed children */
var isNodeOrAllChildrenFixed = R.anyPass([_isFixed.default, isAllChildrenFixed]);
var isAllFixed = R.all(isNodeOrAllChildrenFixed);
var isDynamic = R.hasPath(['props', 'render']);
var isFootnoteView = R.hasPath(['props', 'renderFootnotes']);
var compose = function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (value) {
    var result = value;
    var reversedFns = R.reverse(fns);
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    for (var i = 0; i < reversedFns.length; i += 1) {
      var fn = reversedFns[i];
      result = fn.apply(void 0, [result].concat(args));
    }
    return result;
  };
};
var relayoutPage = compose(_resolveTextLayout.default, _resolveInheritance.default, _resolveDimensions.resolvePageDimensions);
var shouldResolveDynamicNodes = function shouldResolveDynamicNodes(node) {
  var children = node.children || [];
  return isDynamic(node) || isFootnoteView(node) || children.some(shouldResolveDynamicNodes);
};
var resolveDynamicNodes = function resolveDynamicNodes(props, node) {
  var isNodeDynamic = isDynamic(node) || isFootnoteView(node);

  // Call render prop on dynamic nodes and append result to children
  var resolveChildren = function resolveChildren(children) {
    if (children === void 0) {
      children = [];
    }
    if (isNodeDynamic) {
      if (node.props.render) {
        var res = node.props.render(props);
        return [(0, _createInstance.default)(res)].filter(Boolean);
      }

      // render footnotes only if they are passed;
      if (node.props.renderFootnotes && props.footnotesView) {
        return [props.footnotesView].filter(Boolean);
      }

      // if null is passed as the footnoteView; clear contents
      if (node.props.renderFootnotes && props.footnotesView === null) {
        return [];
      }
    }
    return children.map(function (c) {
      return resolveDynamicNodes(props, c);
    });
  };

  // We reset dynamic node box so it can be computed again later on
  var resolveBox = function resolveBox(box) {
    return isNodeDynamic ? (0, _extends2.default)({}, box, {
      height: 0
    }) : box;
  };
  return R.evolve({
    box: resolveBox,
    children: resolveChildren,
    lines: function lines(prev) {
      return isNodeDynamic ? null : prev;
    }
  }, node);
};
var resolveDynamicPage = function resolveDynamicPage(props, page, fontStore) {
  if (shouldResolveDynamicNodes(page)) {
    var resolvedPage = resolveDynamicNodes(props, page);
    return relayoutPage(resolvedPage, fontStore);
  }
  return page;
};
var splitPage = function splitPage(page, pageNumber, fontStore) {
  var wrapArea = (0, _getWrapArea.default)(page);
  var contentArea = (0, _getContentArea.default)(page);
  var height = R.path(['style', 'height'], page);
  var width = R.path(['style', 'width'], page);
  var dynamicPage = resolveDynamicPage({
    pageNumber: pageNumber,
    footnotesView: null
  }, page, fontStore);
  var relayout = function relayout(node) {
    return relayoutPage(node, fontStore);
  };
  var resolvePageWithFootnotes = function resolvePageWithFootnotes(footnotes) {
    return resolveDynamicPage({
      pageNumber: pageNumber,
      footnotesView: (0, _mapFootnotesToView.default)(footnotes, width)
    }, page, fontStore);
  };
  var _splitNodes = (0, _splitNodes4.default)(wrapArea, contentArea, dynamicPage.children),
    currentChildren = _splitNodes[0],
    nextChildren = _splitNodes[1];
  var pageFootnotes = (0, _getFootnotes.default)({
    children: currentChildren
  });
  var resolvedPage = resolvePageWithFootnotes(pageFootnotes);
  var footnotesPlaceholder = (0, _getFootnotePlaceholder.default)(resolvedPage);
  var chosenFootnotes = (0, _chooseFootnotes.default)(resolvedPage, pageFootnotes);
  if (chosenFootnotes.footnotes.length > 0 && footnotesPlaceholder) {
    resolvedPage = resolvePageWithFootnotes(chosenFootnotes.footnotes);
    footnotesPlaceholder = (0, _getFootnotePlaceholder.default)(resolvedPage);
    var spacing = getHeight(footnotesPlaceholder) + chosenFootnotes.spacingNeeded;
    if (footnotesPlaceholder) {
      var _splitNodes2 = (0, _splitNodes4.default)(wrapArea - spacing, contentArea - spacing, resolvedPage.children);
      currentChildren = _splitNodes2[0];
      nextChildren = _splitNodes2[1];
      footnotesPlaceholder.style.marginTop = chosenFootnotes.spacingNeeded;
      if (R.isEmpty(nextChildren) || isAllFixed(nextChildren)) {
        var contentHeight = getHeight(page);
        var pageHeight = page.style.height;
        var footnotesHeight = getHeight(footnotesPlaceholder);
        var lastPageSpacing = pageHeight - contentHeight - footnotesHeight;
        footnotesPlaceholder.style.marginTop = lastPageSpacing;
      }
    }
  } else {
    var updatedWrapArea = wrapArea - chosenFootnotes.spacingNeeded;
    var _splitNodes3 = (0, _splitNodes4.default)(updatedWrapArea, contentArea - chosenFootnotes.spacingNeeded, dynamicPage.children);
    currentChildren = _splitNodes3[0];
    nextChildren = _splitNodes3[1];
  }
  var currentPage = R.compose(relayout, assingChildren(currentChildren), R.assocPath(['box', 'height'], height))(page);
  if (R.isEmpty(nextChildren) || isAllFixed(nextChildren)) return [currentPage, null];
  var nextPage = R.compose(relayout, assingChildren(nextChildren), R.dissocPath(['box', 'height']))(page);
  return [currentPage, nextPage];
};
var resolvePageIndices = function resolvePageIndices(fontStore, pageNumberOffset) {
  return function (page, pageIndex, pages) {
    var totalPages = pages.length + pageNumberOffset;
    var props = {
      totalPages: totalPages,
      pageNumber: pageIndex + pageNumberOffset + 1,
      subPageNumber: page.subPageNumber + 1,
      subPageTotalPages: page.subPageTotalPages
    };
    return resolveDynamicPage(props, page, fontStore);
  };
};

/**
 * Applies the dynamic inside/outside margins based on page parity.
 * Before this process, marginInside is applied to left side, and marginOutside is applied to right side
 * This process swaps the values for odd page indexes (hence even page numbers)
 * @param {Object} page Page
 * @param {number} pageIndex Page index
 */
var applyInsideOutsideMargins = function applyInsideOutsideMargins(pageNumberOffset) {
  return function (page, pageIndex) {
    if ((pageIndex + pageNumberOffset) % 2 === 0) {
      return page;
    }
    var shiftNodeHorizontally = function shiftNodeHorizontally(node, shiftX) {
      // if the node has no box (hence no positioning), return the original
      if (!node.box) {
        return node;
      }

      // if the node has specified a marginInside / a marginOutside, add it
      var additionalShiftX = 0;
      if (node.style) {
        if (node.style.marginInside) {
          additionalShiftX -= node.style.marginInside;
        }
        if (node.style.marginOutside) {
          additionalShiftX += node.style.marginOutside;
        }
      }
      var effectiveShiftX = shiftX + additionalShiftX;
      var shiftedNode = (0, _extends2.default)({}, node, {
        box: (0, _extends2.default)({}, node.box, {
          left: node.box.left + effectiveShiftX,
          right: node.box.right - effectiveShiftX,
          marginLeft: node.box.marginLeft + effectiveShiftX,
          marginRight: node.box.marginRight - effectiveShiftX
        })
      });
      if (node.children) {
        shiftedNode.children = node.children.map(function (child) {
          return shiftNodeHorizontally(child, 0);
        });
      }
      return shiftedNode;
    };
    return (0, _extends2.default)({}, page, {
      children: (page.children || []).map(function (child) {
        return shiftNodeHorizontally(child, 0);
      })
    });
  };
};
var assocSubPageData = function assocSubPageData(subpages) {
  return subpages.map(function (page, i) {
    return (0, _extends2.default)({}, page, {
      subPageNumber: i,
      subPageTotalPages: subpages.length
    });
  });
};
var dissocSubPageData = function dissocSubPageData(page) {
  return R.compose(R.dissoc('subPageNumber'), R.dissoc('subPageTotalPages'))(page);
};
var paginate = function paginate(page, pageNumber, fontStore) {
  if (!page) return [];
  var splittedPage = splitPage(page, pageNumber, fontStore);
  var pages = [splittedPage[0]];
  var nextPage = splittedPage[1];
  while (nextPage !== null) {
    splittedPage = splitPage(nextPage, pageNumber + pages.length, fontStore);
    pages.push(splittedPage[0]);
    nextPage = splittedPage[1];
  }
  return pages;
};

/**
 * Performs pagination. This is the step responsible of breaking the whole document
 * into pages following pagiation rules, such as `fixed`, `break` and dynamic nodes.
 *
 * @param {Object} node
 * @param {Object} fontStore font store
 * @returns {Object} layout node
 */
var resolvePagination = function resolvePagination(doc, fontStore) {
  var _doc$props;
  var pageNumberOffset = ((_doc$props = doc.props) === null || _doc$props === void 0 ? void 0 : _doc$props.pageNumberOffset) || 0;
  var pages = [];
  var pageNumber = 1 + pageNumberOffset;
  for (var i = 0; i < doc.children.length; i += 1) {
    var page = doc.children[i];
    var subpages = paginate(page, pageNumber, fontStore);
    subpages = assocSubPageData(subpages);
    pageNumber += subpages.length;
    pages = pages.concat(subpages);
  }
  pages = pages.map(R.compose(dissocSubPageData, resolvePageIndices(fontStore, pageNumberOffset)));
  pages = pages.map(applyInsideOutsideMargins(pageNumberOffset));
  return assingChildren(pages, doc);
};
var _default = exports.default = resolvePagination;